module.exports = fox._r("images/promo/tutorial/03.png", __webpack_public_path__ + "_/common/images/promo/tutorial/03.png");


//////////////////
// WEBPACK FOOTER
// ../common/images/promo/tutorial/03.png
// module id = 652
// module chunks = 2